<template>
  <iframe
    style="width: 100vw; height: 100vh"
    :src="thankYouPageUrl"
    :title="thankYouPageTitle"
    frameborder="0"
    allowfullscreen
  ></iframe>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ThankYouPage",

  computed: {
    ...mapGetters(["thankYouPageUrl", "thankYouPageTitle"]),
  },
};
</script>

<style lang="scss" scoped>
.c-font-poppins {
  font-family: Poppins !important;
}

.c-font-montserrat {
  font-family: Montserrat !important;
}

.c-font-14-400 {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 22.4px !important;
}

.c-font-14-400-21 {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 21px !important;
}

.c-font-14-500 {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 21px !important;
}

.c-font-14-600 {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 22.4px !important;
}

.c-text-underline {
  text-decoration-line: underline !important;
  text-decoration-style: solid !important;
}

.c-text-common {
  text-align: left;
  text-underline-position: from-font !important;
  text-decoration-skip-ink: none !important;
}

.install-title {
  @extend .c-font-montserrat;
  @extend .c-text-common;
  font-size: 22px;
  font-weight: 500;
  line-height: 39.6px;
  color: #000000;
}

.install-extension .row {
  margin: 0px;
}

.install-extension .layout {
  min-width: initial;
}

.install-step-number-inactive {
  background: white !important;
  color: #9a9a9a !important;
  border: 1px solid #9a9a9a !important;
}

.install-info {
  @extend .c-font-poppins;
  @extend .c-font-14-400;
  @extend .c-text-common;
  color: #2c58a0;
}

.install-info-non-admin {
  @extend .c-font-poppins;
  @extend .c-font-14-400;
  @extend .c-text-underline;
  @extend .c-text-common;
  color: #2c58a0;
}

.install-step-number {
  @extend .c-font-poppins;
  @extend .c-text-common;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: #ffffff;
}

.install-step-title {
  @extend .c-font-poppins;
  @extend .c-text-common;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #747474;
}

.install-button-doc {
  @extend .c-font-poppins;
  @extend .c-text-underline;
  @extend .c-text-common;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #3498db;
}

.install-content-workspace {
  @extend .c-font-poppins;
  @extend .c-font-14-400-21;
  @extend .c-text-common;
  color: #747474;
}

.install-content-success {
  @extend .c-font-poppins;
  @extend .c-text-common;
  @extend .c-font-14-500;
  color: #42a574;
}

.install-sheet-error {
  max-width: fit-content;
  background-color: #f9e1e5;
  border: 1px solid #af233a66;
}

.install-button-action {
  @extend .c-font-poppins;
  @extend .c-text-common;
  @extend .c-font-14-500;
  color: white;
}

.install-new-tab-text {
  @extend .c-font-poppins;
  @extend .c-font-14-400;
  @extend .c-text-common;
  color: #747474;
}

.install-progress-text {
  @extend .c-font-poppins;
  @extend .c-font-14-600;
  @extend .c-text-common;
  color: #2c58a0;
}

.install-invite-header {
  border-bottom: 1px solid #d7d7d7 !important;
}

.install-invite-title {
  @extend .c-font-poppins;
  @extend .c-text-common;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0.3339366316795349px;
  color: #2b2c2d;
}

.install-invite-field {
  @extend .c-font-poppins;
  @extend .c-font-14-500;
  @extend .c-text-common;
  color: black;
}

.install-invite-copy {
  @extend .c-font-poppins;
  @extend .c-font-14-500;
  @extend .c-text-common;
  letter-spacing: 0.3339366316795349px;
  color: #4d4d4d;
}

.install-invite-input {
  @extend .c-font-poppins;
  @extend .c-font-14-400-21;
  @extend .c-text-common;
  color: #909090;
}

.subject {
  @extend .c-text-common;
  @extend .c-font-14-500;
  color: #909090;
  font-family: "Poppins", sans-serif;
}
</style>

<style>
.install-extension .v-text-field--outlined fieldset {
  border: 1px solid #adadad !important;
  border-radius: 9px;
}
.install-extension .v-text-field--outlined.v-input--is-focused fieldset {
  border: 2px solid #adadad !important;
}

#subject-text-field
  .install-invite-input
  .v-input__control
  .v-input__slot
  fieldset {
  border: 1px solid #d5d5d5 !important;
}
</style>
